<div  class="mainLoginContainer container-fluid">
    <div class="mainLoginContainer1 row main-content bg-success text-center">
      <div class="col-md-4 text-center company__info">
        <!-- <span class="company__logo"><h2><span class="fa fa-android"></span></h2></span> -->
        <img src="../../assets/img/frankylogo.svg" class="frankylogo">
      </div>
      <div class="col-md-8 col-xs-12 col-sm-12 login_form ">
        <div class="loginContainer container-fluid">
          <div class="row">
            <h2 style="color:black;">Register Here</h2>
          </div>
          <div class="row">
            <form control="" class="form-group" (ngSubmit)="onSubmit()" >
              <div class="row">
                <input [(ngModel)]="newCustomer.Contact" type="text" name="contact" id="contact" class="form__input" placeholder="Mobile no">
              </div>
              <div class="row">
                <input [(ngModel)]="newCustomer.CustomerName" type="text" name="customerName" id="customerName" class="form__input" placeholder="Name">
              </div>
              <div class="row">
                <input [(ngModel)]="newCustomer.EmailId" type="text" name="emailId" id="emailId" class="form__input" placeholder="Email Id">
              </div>
              <!--  <div class="row">
             
                <input type="password" name="password" id="password" class="form__input" placeholder="Password">
              </div> -->
             
              <div>
                <input type="submit" value="Submit" class="Submitbtn" >
              </div>
            </form>
          </div>
          
        </div>
      </div>
    </div>
  </div>